import {
  FETCH_ALL_PRODUCTS,
  FETCH_PRODUCT,
  CREATE_PRODUCT,
  UPDATE_PRODUCT,
  DELETE_PRODUCT,
} from "../types";

const initialState = {
  loading: false,
  message: null,
  data: [],
};

export const productsReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_ALL_PRODUCTS}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_ALL_PRODUCTS}_FULFILLED`:
      const result = action.payload.data ? action.payload.data.results : {};
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data?.message || "",
      };

    case `${FETCH_ALL_PRODUCTS}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_PRODUCT}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_PRODUCT}_FULFILLED`:
      const result = action.payload.data.results
        ? action.payload.data.results
        : {};
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data.message,
      };

    case `${FETCH_PRODUCT}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const createProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${CREATE_PRODUCT}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${CREATE_PRODUCT}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
      };

    case `${CREATE_PRODUCT}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const updateProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${UPDATE_PRODUCT}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${UPDATE_PRODUCT}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${UPDATE_PRODUCT}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const deleteProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${DELETE_PRODUCT}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${DELETE_PRODUCT}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload ? action.payload.message : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${DELETE_PRODUCT}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};
